/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody, Card } from "../ContentLayout";
import Form from "../Form";
import ToolTip from "../ToolTip/ToolTip";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { isEmpty, get, isNumber, isNaN } from "lodash";
import {
  createPartnerSite,
  getPartnerSite,
  modifyPartnerSite,
  urlDuplicationCheck,
} from "../../apis/partner/partner-site";
import { viewLoading } from "../../utils/loading";
import { newWindow } from "../../utils/browser";
// import { isAdmin } from "../../utils/auth";
import PartnerSiteA1 from "../../assets/images/partners/site/partner-site-a-1.png";
import PartnerSiteA2 from "../../assets/images/partners/site/partner-site-a-2.png";
import PartnerSiteA3 from "../../assets/images/partners/site/partner-site-a-3.png";
import PartnerSiteA4 from "../../assets/images/partners/site/partner-site-a-4.png";
import PartnerSiteA5 from "../../assets/images/partners/site/partner-site-a-5.png";
import PartnerSiteB1 from "../../assets/images/partners/site/partner-site-b-1.png";
import PartnerSiteB2 from "../../assets/images/partners/site/partner-site-b-2.png";
import PartnerSiteB3 from "../../assets/images/partners/site/partner-site-b-3.png";
import PartnerSiteB4 from "../../assets/images/partners/site/partner-site-b-4.png";
import PartnerSiteB5 from "../../assets/images/partners/site/partner-site-b-5.png";
import { addressToCoord } from "../../apis/maps";
import { toast } from "../../utils/toast";
import { modifyPartner } from "../../apis/partner/partner";
import { restoreComma, transformComma } from "../../utils/validator/comma";
import Button from "../Button";
const HOMEPAGE_TYPES = [
  {
    type: "A",
    colors: [["#414795"], ["#80539c"], ["#5c5c72"], ["#88a9c8"], ["#E57C7C"]],
    sampleUrl: "http://wecake.io/partners/a",
  },
  {
    type: "B",
    colors: [["#f57874"], ["#f5ab74"], ["#986fb1"], ["#558edf"], ["#5CBA9F"]],
    sampleUrl: "http://wecake.io/partners/b",
  },
];
const PARTNER_PAGES = {
  A: {
    1: {
      color: "#414795",
      label: "네이비",
      preview: PartnerSiteA1,
      type: "A",
      sampleUrl: "http://wecake.io/partners/a",
    },
    2: {
      color: "#80539C",
      label: "퍼플",
      preview: PartnerSiteA2,
      type: "A",
      sampleUrl: "http://wecake.io/partners/a",
    },
    3: {
      color: "#5C5C72",
      label: "그레이",
      preview: PartnerSiteA3,
      type: "A",
      sampleUrl: "http://wecake.io/partners/a",
    },
    4: {
      color: "#88A9C8",
      label: "스카이블루",
      preview: PartnerSiteA4,
      type: "A",
      sampleUrl: "http://wecake.io/partners/a",
    },
    5: {
      color: "#E57C7C",
      label: "핑크",
      preview: PartnerSiteA5,
      type: "A",
      sampleUrl: "http://wecake.io/partners/a",
    },
  },
  B: {
    1: {
      type: "B",
      color: "#F5AA74",
      label: "오렌지",
      preview: PartnerSiteB1,
      sampleUrl: "http://wecake.io/partners/b",
    },
    2: {
      type: "B",
      color: "#F57874",
      label: "레드",
      preview: PartnerSiteB2,
      sampleUrl: "http://wecake.io/partners/b",
    },
    3: {
      type: "B",
      color: "#986FB1",
      label: "퍼플",
      preview: PartnerSiteB3,
      sampleUrl: "http://wecake.io/partners/b",
    },
    4: {
      type: "B",
      color: "#558E",
      label: "블루",
      preview: PartnerSiteB4,
      sampleUrl: "http://wecake.io/partners/b",
    },
    5: {
      color: "#5CBA9F",
      label: "민트",
      preview: PartnerSiteB5,
      type: "B",
      sampleUrl: "http://wecake.io/partners/b",
    },
  },
};

const PartnerSiteForm = (props) => {
  const siteType = useMemo(
    () =>
      get(
        PARTNER_PAGES,
        `[${props?.form?.type || "A"}][${props?.form?.colorType || "1"}]`
      ),
    [props.form]
  );

  return (
    <>
      <h4 className="page-title">파트너스 설정</h4>
      <div className="partner-form-wrap">
        <div className="partner-form">
          <Form {...props} />
        </div>
        <div className="partner-form">
          {siteType && (
            <div className="partner-preview-image-wrap">
              <h5 className="section-title">
                타입별 미리보기 : {siteType.type} - {siteType.label}
              </h5>
              <img
                className="partner-preview-image"
                src={siteType.preview}
                alt="파트너 사이트 프리뷰"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const PartnerSiteInfo = (props) => {
  const { partnerCompanyIdx, mode = "create" } = props;

  const [isReady, setIsReady] = useState(false);
  const [companyIdx, setCompanyIdx] = useState(null);
  const [checkUrl, setCheckUrl] = useState("");

  const { company, permissions } = useSelector(
    (store) => ({
      company: store.Profile.company,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (company) {
      setCompanyIdx(partnerCompanyIdx || company.managerCompanyIdx);
    }
    if (company && companyIdx && !isEmpty(permissions)) {
      setPartnerSite();
    }
  }, [company, permissions, companyIdx]);

  const setPartnerSite = async () => {
    viewLoading(true);
    let partnerSite = await getPartnerSite(companyIdx);
    if (isEmpty(partnerSite)) {
      await createPartnerSite({
        ...form,
        url: companyIdx,
        type: "A",
        colorType: "1",
        companyIdx: companyIdx,
      });
      partnerSite = await getPartnerSite(companyIdx);
    }

    const data = {
      ...partnerSite,
      individualPrice: transformComma(partnerSite.individualPrice),
      corporationPrice: transformComma(partnerSite.corporationPrice),
      supportPrice: transformComma(partnerSite.supportPrice),
      mainBannerFileIdx: partnerSite.mainBannerFile
        ? [partnerSite.mainBannerFile]
        : [],
      logoFileIdx: partnerSite.logoFile ? [partnerSite.logoFile] : [],
      moMainBannerFileIdx: partnerSite.moMainBannerFile
        ? [partnerSite.moMainBannerFile]
        : [],
      sloganImageIdxes: partnerSite.sloganImages,
      peopleImageIdx: partnerSite.peopleImage ? [partnerSite.peopleImage] : [],
      isActive: partnerSite.isActive ? "1" : "0",
      companyIdx: companyIdx,

      // partner info
      shortName: partnerSite.partner.shortName,
      ceoName: partnerSite.partner.ceoName,
      address: partnerSite.partner.address,
      addressDetail: partnerSite.partner.addressDetail,
      longitude: partnerSite.partner.longitude,
      latitude: partnerSite.partner.latitude,
      tel: partnerSite.partner.tel,
      mobile: partnerSite.partner.mobile,
      email: partnerSite.partner.email,
      kakaoId: partnerSite.partner.kakaoId,
      blog: partnerSite.partner.blog,
      youtube: partnerSite.partner.youtube,
      facebook: partnerSite.partner.facebook,
      instar: partnerSite.partner.instar,
      isUrlCheck: true,
    };

    setOriginForm(data);
    setForm(data);
    setIsReady(true);
    viewLoading(false);
  };

  const validate = ({ url }) => {
    let errors = {};
    if (!url) errors.url = "URL은 필수입니다.";
    else if (!isNaN(Number(url))) {
      errors.url = "URL은 숫자로만 사용할 수 없습니다.";
      systemAlert(errors.url);
    }
    return errors;
  };

  const getParams = (params) => {
    const _params = { ...params };

    _params.mainBannerFileIdx = get(
      _params,
      "mainBannerFileIdx[0].fileIdx",
      get(_params, "mainBannerFileIdx[0]", null)
    );
    _params.logoFileIdx = get(
      _params,
      "logoFileIdx[0].fileIdx",
      get(_params, "logoFileIdx[0]", null)
    );
    _params.moMainBannerFileIdx = get(
      _params,
      "moMainBannerFileIdx[0].fileIdx",
      get(_params, "moMainBannerFileIdx[0]", null)
    );
    _params.peopleImageIdx = get(
      _params,
      "peopleImageIdx[0].fileIdx",
      get(_params, "peopleImageIdx[0]", null)
    );
    _params.sloganImageIdxes = (_params.sloganImageIdxes || []).map((item) => {
      return isNumber(item) ? item : item.fileIdx;
    });
    delete _params.createdTime;
    delete _params.updatedTime;
    delete _params.deletedTime;
    delete _params.shortName;
    delete _params.ceoName;
    delete _params.address;
    delete _params.addressDetail;
    delete _params.longitude;
    delete _params.latitude;
    delete _params.tel;
    delete _params.mobile;
    delete _params.email;
    delete _params.kakaoId;
    delete _params.blog;
    delete _params.youtube;
    delete _params.facebook;
    delete _params.instar;
    return _params;
  };

  const getParterParams = (params) => {
    return {
      companyIdx: params.companyIdx,
      shortName: params.shortName,
      ceoName: params.ceoName,
      address: params.address,
      addressDetail: params.addressDetail,
      longitude: params.longitude,
      latitude: params.latitude,
      tel: params.tel,
      mobile: params.mobile,
      email: params.email,
      kakaoId: params.kakaoId,
      blog: params.blog,
      youtube: params.youtube,
      facebook: params.facebook,
      instar: params.instar,
    };
  };

  const _submit = (form) => {

    const siteForm = {
      ...form,
      individualPrice: 100000 > +restoreComma(form.individualPrice)
        ? 100000
        : form.individualPrice,
      corporationPrice: 150000 > +restoreComma(form.corporationPrice)
        ? 150000
        : form.corporationPrice,
      supportPrice: 500000 > +restoreComma(form.supportPrice)
        ? 500000
        : form.supportPrice,


    };

    if (!form?.isUrlCheck) {
      systemAlert("URL 중복확인은 필수입니다.");
      return;
    }

    systemAlert("홈페이지 정보를 적용하시겠습니까?", {
      buttons: [
        {
          color: "text",
          label: "취소",
        },
        {
          label: "확인",
          onClick: async () => {
            await modifyPartner(form.partner.idx, getParterParams(form));
            await modifyPartnerSite(form.idx, getParams(siteForm));
            systemAlert("홈페이지 내용이 적용 되었습니다.");
            setPartnerSite();
          },
        },
      ],
    });
  };

  const { form, setForm, originForm, setOriginForm, errors, handleOnChange, handleSubmit, setValidateFields } =
    useForm(
      {
        isActive: "0",
        url: get(company, "idx"),
        logoFileIdx: null,
        mainBannerFileIdx: null,
        moMainBannerFileIdx: null,
        mainBannerTitle:
          '전문가의 절세서비스에<br className="mo_mode" /> 친절을 더하고 있습니다.',
        sloganImageIdxes: null,
        type: null,
        colorType: null,
        TopBannerTitle: null,
        sloganTitle:
          '외부교육기관을 통한<br />전문가 교육 및 실무교육을 통해<br className="mo_mode" />실력을 갖추고 있습니다.',
        sloganContents:
          '친절하고, 빠른응대 그리고 전문가의 실력으로<br className="mo_mode" /> 고객만족을 실현하겠습니다.<br />고객의 소중한 시간을 위해 전화주시면<br className="mo_mode" /> 담당 매니저가 바로 응대합니다.',
        peopleTitle: "전문가의 실력으로 고객만족을<br />실현하겠습니다.",
        peopleRecords:
          "<h4><strong>대표 세무사</strong>&nbsp;&nbsp;XXX</h4><ul><li>어디어디 시민위원(전)</li><li>어디어디 상임위원(전)</li><li>어디어디 출연</li></ul>",
        peopleImageIdx: null,
        locationTitle: "지금 바로 만나보세요.",
        // partner info
        shortName: null,
        ceoName: null,
        address: null,
        addressDetail: null,
        longitude: null,
        latitude: null,
        tel: null,
        mobile: null,
        email: null,
        kakaoId: null,
        blog: null,
        youtube: null,
        facebook: null,
        instar: null,
        individualPrice: "100000",
        corporationPrice: "150000",
        supportPrice: "500000",
        consultingPrice: "Case By Case",
      },
      _submit,
      validate
    );

  const [fields, setFields] = useState([]);

  const getCoord = async (form, setForm) => {
    if (form.address) {
      const address = form.address;
      const addresses = await addressToCoord({ address });
      if (addresses.length > 0) {
        form.latitude = addresses[0].y;
        form.longitude = addresses[0].x;
        setForm({ ...form });
      } else {
        toast.error("주소를 정확히 입력해주세요");
      }
    } else {
      toast.error("주소 입력 후 변환해 주세요.");
    }
  };

  const urlCheck = (url) => {

    urlDuplicationCheck(form.idx, url)
      .then(res => {
        if (res) {
          setCheckUrl(url);
        } else {
          systemAlert("이미 사용중인 URL 입니다.");
        }
        setForm({ isUrlCheck: res });
      });
  };

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    setFields([
      {
        type: "title",
        title: <>홈페이지 설정</>,
      },
      [
        {
          title: "활성여부",
          key: "isActive",
          type: "radio",
          options: {
            list: [
              { label: "활성", value: "1" },
              { label: "비활성", value: "0" },
            ],
          },
          required: true,
        },
      ],
      [
        {
          title: "URL",
          tooltip: (
            <>
              홈페이지 사용될 URL
              <br />
              https://"URL".wecake.io
              <br />
              활성 및 저장 후 해당 url로 홈페이지 접속 가능합니다.
              <br />
              최초 기본설정 외에는 숫자만으로 구성할수 없습니다.
              <br />
              url 변경시 중복확인을 진행해주세요
            </>
          ),
          tooltipPosition: "top",
          key: "url",
          type: "input",
          required: true,
          // disabled: !isAdmin(),
          after: form?.isUrlCheck ? "사용 가능한 url 입니다." : "url 중복확인을 진행해주세요.",
          // after: "url관련은 관리자에게 문의해주세요.",
          width: "70%",

          onChange: (e) => {
            const { name, value } = e.target;
            const isUrlCheck = originForm.url === value || checkUrl === value;
            setForm({
              [name]: value,
              isUrlCheck,
            });
          }
        },
        {
          type: "component",
          labelWidth: 0,
          width: "20%",
          key: "isUrlCheck",
          component: () => (

            <>
              <Button
                label={"중복확인"}
                action={() => urlCheck(form.url)}
                style={{ width: "100px" }}
                // color={form?.isUrlCheck ? "" : "primary"}
                disabled={form.isUrlCheck}
              />
            </>
          )
        },


      ],
      [
        {
          title: "홈페이지 타입",
          key: "type",
          type: "select",
          options: {
            list: HOMEPAGE_TYPES.map((h) => ({
              type: h.type,
              label: h.type,
            })),
          },
          required: true,
          after: (
            <>
              {HOMEPAGE_TYPES.map((h, indx) => (
                <a
                  key={indx}
                  href={h.sampleUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  타입{h.type} 샘플
                </a>
              ))}
            </>
          ),
        },
      ],
      [
        {
          title: "컬러 타입",
          key: "colorType",
          type: "select",
          options: {
            list: [
              { label: "1", value: "1" },
              { label: "2", value: "2" },
              { label: "3", value: "3" },
              { label: "4", value: "4" },
              { label: "5", value: "5" },
            ],
          },
          required: true,
          after: (
            <>
              {HOMEPAGE_TYPES.map((h, idx) => {
                return (
                  <div style={{ lineHeight: 1.5 }} key={idx}>
                    타입{h.type}
                    {h.colors.map((color, index) => (
                      <>
                        {index + 1}번
                        <span
                          className="color-palette"
                          key={index}
                          style={{ background: color }}
                        ></span>
                      </>
                    ))}
                  </div>
                );
              })}
            </>
          ),
        },
      ],
      {
        type: "title",
        title: (
          <>
            홈페이지 컨텐츠
            <ToolTip
              tooltiptext={
                <span style={{ fontSize: "12px", lineHeight: "15px" }}>
                  HTML tag 사용이 가능합니다.
                  <br /> pc_mode, mo_mode 클레스를 이용하여 각각 버전에
                  노출가능합니다.
                  <br /> 추천 비율과 다르더라도 표기가 가능합니다.
                </span>
              }
            ></ToolTip>
          </>
        ),
      },
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">1</span>
              </div>
              <div className="partner-form-title">
                로고
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">
                  150x22 픽셀
                  <br />
                  *PNG 파일 권장
                </div>
              </div>
            </div>
          ),
          key: "logoFileIdx",
          type: "dropzone",
          isSingle: true,
          labelWidth: 170,
        },
      ],
      // { type: "section-title", title: "메인배너" },
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">2</span>
              </div>
              <div className="partner-form-title">
                메인 배너 (PC)
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">
                  A타입 : 2880x1426 픽셀
                  <br />
                  B타입 : 2880x2789 픽셀
                </div>
              </div>
            </div>
          ),
          labelWidth: 170,
          key: "mainBannerFileIdx",
          type: "dropzone",
          isSingle: true,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">2</span> */}
              </div>
              <div className="partner-form-title">
                메인 배너 (모바일)
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">
                  A타입 : 1440x1416 픽셀
                  <br />
                  B타입 : 1440x1528 픽셀
                </div>
              </div>
            </div>
          ),
          labelWidth: 170,
          key: "moMainBannerFileIdx",
          type: "dropzone",
          isSingle: true,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">2</span> */}
              </div>
              <div className="partner-form-title">
                메인 배너 텍스트
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "메인 배너 텍스트 입력",
          labelWidth: 170,
          key: "mainBannerTitle",
          type: "textarea",
        },
      ],
      // { type: "section-title", title: "중간 소개" },
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">3</span>
              </div>
              <div className="partner-form-title">
                중간 소개 이미지
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">
                  A타입(3개) : 786x524 픽셀
                  <br />
                  B타입(1개) : 926x808 픽셀
                </div>
              </div>
            </div>
          ),
          labelWidth: 170,
          key: "sloganImageIdxes",
          type: "dropzone",
          // after: "A타입 : 이미지 3개 786x524 비율, B타입 : 이미지 1개 962x808",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">2</span> */}
              </div>
              <div className="partner-form-title">
                중간 소개 제목
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "중간 소개 제목 입력",
          labelWidth: 170,
          key: "sloganTitle",
          type: "input",
          after: `엔터(줄바꿈)로 구분해주세요.`,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">2</span> */}
              </div>
              <div className="partner-form-title">
                중간 소개 내용
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "중간 소개 내용 입력",
          labelWidth: 170,
          key: "sloganContents",
          type: "textarea",
          after: `엔터(줄바꿈)로 구분해주세요.`,
        },
      ],
      // { type: "section-title", title: "대표 소개" },
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">4</span>
              </div>
              <div className="partner-form-title">
                대표이름
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          labelWidth: 170,
          placeholder: "대표이름 입력",
          key: "ceoName",
          type: "input",
          // after: whereToUse(true, false),
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">4</span> */}
              </div>
              <div className="partner-form-title">
                대표 이미지
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">572x662 픽셀</div>
              </div>
            </div>
          ),
          labelWidth: 170,
          key: "peopleImageIdx",
          type: "dropzone",
          isSingle: true,
        },
      ],
      {
        title: (
          <div className="partner-form-title-wrap">
            <div className="partner-form-title-before-wrap">
              {/* <span className="round-num green">4</span> */}
            </div>
            <div className="partner-form-title">
              표시 상호
              {/* <span class="color-red-100">&nbsp;*</span> */}
            </div>
          </div>
        ),
        labelWidth: 170,
        placeholder: "표시 상호 입력",
        key: "shortName",
        type: "input",
      },
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">2</span> */}
              </div>
              <div className="partner-form-title">
                대표 소개 제목
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "대표 소개 제목 입력",
          labelWidth: 170,
          key: "peopleTitle",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">4</span> */}
              </div>
              <div className="partner-form-title">
                대표 소개 내용
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "대표 소개 내용 입력",
          labelWidth: 170,
          key: "peopleRecords",
          type: "textarea",
          after: `엔터(줄바꿈)로 구분해주세요.`,
        },
      ],
      // { type: "section-title", title: "지도 영역" },
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">5</span>
              </div>
              <div className="partner-form-title">
                지도 위 문구
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "지도 위 문구 입력",
          labelWidth: 170,
          key: "locationTitle",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">6</span>
              </div>
              <div className="partner-form-title">
                주소
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "주소 입력",
          key: "address",
          type: "address",
          // after: whereToUse(true, true),
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green"></span> */}
              </div>
              <div className="partner-form-title">
                경도/위도
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          key: "longitude",
          type: "input",
          placeholder: "경도 입력",
          // tooltip:
          //   "변환된 좌표는 정확하지 않을 수 있습니다. 직접수정도 가능합니다.",
          // after: whereToUse(true, true),
          labelWidth: 170,
          width: "60%",
        },
        {
          title: false,
          key: "latitude",
          placeholder: "위도 입력",
          type: "input",
          // after: whereToUse(true, true),
          className: "pr-0",
          width: "40%",
        },
      ],
      [
        {
          title: <> </>,
          placeholder: "경도/위도 입력",
          type: "button",
          color: "gray-line",
          label: "주소를 좌표로 변환",
          action: () => {
            getCoord(form, setForm);
          },
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">7</span>
              </div>
              <div className="partner-form-title">
                상담전화
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "상담전화 입력",
          labelWidth: 170,
          key: "tel",
          type: "input",
          // after: `${whereToUse(true, true)}, 텍스트 및 숫자 사용가능`,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">7</span> */}
              </div>
              <div className="partner-form-title">
                모바일
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "모바일 입력",
          labelWidth: 170,
          key: "mobile",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">7</span> */}
              </div>
              <div className="partner-form-title">
                이메일
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "이메일 입력",
          labelWidth: 170,
          key: "email",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">7</span> */}
              </div>
              <div className="partner-form-title">
                카카오ID
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "카카오ID 입력",
          labelWidth: 170,
          key: "kakaoId",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">8</span>
              </div>
              <div className="partner-form-title">
                블로그
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "블로그 입력",
          labelWidth: 170,
          key: "blog",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">7</span> */}
              </div>
              <div className="partner-form-title">
                유튜브
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "유튜브 입력",
          labelWidth: 170,
          key: "youtube",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">7</span> */}
              </div>
              <div className="partner-form-title">
                페이스북
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "페이스북 입력",
          labelWidth: 170,
          key: "facebook",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">7</span> */}
              </div>
              <div className="partner-form-title">
                인스타그램
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "인스타그램 입력",
          labelWidth: 170,
          key: "instar",
          type: "input",
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">9</span>
              </div>
              <div className="partner-form-title">
                기장대리 금액 - 개인
              </div>
            </div>
          ),
          placeholder: "기장대리 개인사업자 금액 입력",
          labelWidth: 170,
          key: "individualPrice",
          type: "input",
          validators: ['comma'],
          // onChange: (e) => {
          //   let { name, value } = e.target;

          // }
        }
      ], [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">9</span>
              </div>
              <div className="partner-form-title">
                기장대리 금액 - 법인
              </div>
            </div>
          ),
          placeholder: "기장대리 법인사업자 금액 입력",
          labelWidth: 170,
          key: "corporationPrice",
          type: "input",
          validators: ['comma'],
        }
      ], [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">9</span>
              </div>
              <div className="partner-form-title">
                경리대행 금액
              </div>
            </div>
          ),
          placeholder: "경리대행 금액 입력",
          labelWidth: 170,
          key: "supportPrice",
          type: "input",
          validators: ['comma'],
        }
      ],
    ]);
  }, [form]);

  const buttons = [
    {
      label: <>사이트보기</>,
      onClick: (e) => {
        if (form.isActive !== "1") {
          return systemAlert(
            "활성 되지 않은 상태에서는 홈페이지를 볼 수 없습니다."
          );
        }
        systemAlert(`적용하지 않은 경우 적용전 정보가 노출될 수 있습니다.`, {
          buttons: [
            {
              color: "text",
              label: "취소",
            },
            {
              label: "보러가기",
              onClick: () => {
                newWindow(`https://${form.url}.wecake.io`, e);
              },
            },
          ],
        });
      },
      color: "line",
      style: { marginRight: "10px" },
    },
    {
      label: "적용하기",
      onClick: handleSubmit,
    },
  ];

  return (
    isReady && (
      <div className="partner-site-wrap">
        {partnerCompanyIdx ? (
          <PartnerSiteForm
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            // submitText={"적용하기"}
            // submit={handleSubmit}
            buttons={buttons}
          // cancel={cancel}
          />
        ) : (
          <Card>
            <CardBody>
              <PartnerSiteForm
                mode={mode}
                form={form}
                errors={errors}
                isRequiredShow={true}
                setForm={setForm}
                fields={fields}
                onChange={handleOnChange}
                // submitText={"적용하기"}
                // submit={handleSubmit}
                buttons={buttons}
              // cancel={cancel}
              />
            </CardBody>
          </Card>
        )}
      </div>
    )
  );
};

export default PartnerSiteInfo;
